
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RaccomandazioniGrid extends Serenity.EntityGrid<RaccomandazioniRow, any> {
        protected getColumnsKey() { return RaccomandazioniColumns.columnsKey; }
        protected getDialogType() { return RaccomandazioniDialog; }
        protected getIdProperty() { return RaccomandazioniRow.idProperty; }
        protected getInsertPermission() { return RaccomandazioniRow.insertPermission; }
        protected getLocalTextPrefix() { return RaccomandazioniRow.localTextPrefix; }
        protected getService() { return RaccomandazioniService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}